import { ENTITLEMENTS_TAG } from '@/model/entitlements/tags';
import { etlSourceApi } from '@/model/etlSource/api.generated';

export const ETL_SOURCES_TAG = 'etl-sources' as const;

export const ETL_SOURCES_LIST_TAG = { type: ETL_SOURCES_TAG, id: 'LIST' } as const;

export const ETL_SOURCES_CONNECTORS_TAG = { type: ETL_SOURCES_TAG, id: 'CONNECTORS' } as const;

export function registerEtlSourcesTags(): void {
  etlSourceApi.enhanceEndpoints({
    endpoints: {
      getApiProjectsByProjectIdEtlSources: {
        providesTags: [ETL_SOURCES_LIST_TAG],
      },
      getApiProjectsByProjectIdEtlSourcesAndSourceId: {
        providesTags: (_result, _error, arg) => [{ type: ETL_SOURCES_TAG, id: arg.sourceId }],
      },
      getApiProjectsByProjectIdEtlSourcesAndSourceIdArtifacts: {
        providesTags: (_result, _error, arg) => [{ type: ETL_SOURCES_TAG, id: arg.sourceId }],
      },
      getApiProjectsByProjectIdEtlSourcesAndSourceIdStatus: {
        providesTags: (_result, _error, arg) => [{ type: ETL_SOURCES_TAG, id: arg.sourceId }],
      },
      getApiProjectsByProjectIdEtlSourcesAndSourceIdView: {
        providesTags: (_result, _error, arg) => [{ type: ETL_SOURCES_TAG, id: arg.sourceId }],
      },
      getApiProjectsByProjectIdEtlSourcesConnectors: {
        providesTags: [ETL_SOURCES_CONNECTORS_TAG],
      },
      deleteApiProjectsByProjectIdEtlSourcesAndSourceId: {
        invalidatesTags: [ETL_SOURCES_TAG, ENTITLEMENTS_TAG],
      },
      patchApiProjectsByProjectIdEtlSourcesAndSourceIdTables: {
        invalidatesTags: [ETL_SOURCES_TAG, ENTITLEMENTS_TAG],
      },
      postApiProjectsByProjectIdEtlSourcesAndSourceIdPublish: {
        invalidatesTags: [ETL_SOURCES_TAG, ENTITLEMENTS_TAG],
      },
      postApiProjectsByProjectIdEtlSourcesReplaceFromUpload: {
        invalidatesTags: [ETL_SOURCES_TAG, ENTITLEMENTS_TAG],
      },
      postApiProjectsByProjectIdEtlSourcesNameCheck: {
        invalidatesTags: [],
      },
      postApiProjectsByProjectIdEtlSourcesProbe: {
        invalidatesTags: [],
      },
      postApiProjectsByProjectIdEtlSourcesDiscover: {
        invalidatesTags: [],
      },
      deleteApiProjectsByProjectIdEtlSourcesOrphanedSilverAndTableName: {
        invalidatesTags: ['mining', 'artifacts'],
      },
    },
  });
}
